import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from '../../../components/AppIcon';

const SocialRegistration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState({
    google: false,
    facebook: false,
    apple: false
  });

  const handleSocialLogin = async (provider) => {
    setIsLoading(prev => ({ ...prev, [provider]: true }));

    try {
      // Mock social registration process
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock success - redirect to dashboard
      navigate('/user-dashboard');
    } catch (error) {
      console.error(`${provider} registration failed:`, error);
    } finally {
      setIsLoading(prev => ({ ...prev, [provider]: false }));
    }
  };

  const socialProviders = [
    {
      name: 'google',
      label: 'Continue with Google',
      icon: 'Chrome',
      bgColor: 'bg-white hover:bg-gray-50',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300'
    },
    {
      name: 'facebook',
      label: 'Continue with Facebook',
      icon: 'Facebook',
      bgColor: 'bg-blue-600 hover:bg-blue-700',
      textColor: 'text-white',
      borderColor: 'border-blue-600'
    },
    {
      name: 'apple',
      label: 'Continue with Apple',
      icon: 'Apple',
      bgColor: 'bg-black hover:bg-gray-900',
      textColor: 'text-white',
      borderColor: 'border-black'
    }
  ];

  return (
    <div className="space-y-3">
      <div className="text-center mb-4">
        <p className="text-sm text-muted-foreground">Quick registration with</p>
      </div>
      {socialProviders?.map((provider) => (
        <button
          key={provider?.name}
          onClick={() => handleSocialLogin(provider?.name)}
          disabled={isLoading?.[provider?.name]}
          className={`w-full flex items-center justify-center space-x-3 px-4 py-3 rounded-lg border transition-micro hover-scale ${provider?.bgColor} ${provider?.textColor} ${provider?.borderColor} disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {isLoading?.[provider?.name] ? (
            <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
          ) : (
            <Icon name={provider?.icon} size={20} />
          )}
          <span className="font-medium">
            {isLoading?.[provider?.name] ? 'Connecting...' : provider?.label}
          </span>
        </button>
      ))}
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">
            Or register with email
          </span>
        </div>
      </div>
    </div>
  );
};

export default SocialRegistration;